import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function CapitalLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === 'admin' && password === 'admin123') {
      navigate('/capital');
    } else {
      alert('Invalid capital credentials. Try admin/admin123');
    }
  };

  return (
    <div style={{ background: '#202020', minHeight: '100vh' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 fixed-top d-flex justify-content-start" style={{ backgroundColor: '#504f4f', padding: '0.5rem 1rem' }}>
            <div className="col ms-3 mt-2 d-flex align-items-center">
              <img src={logo} style={{ height: '5rem', width: '5rem' }} alt="KW" />
              <span style={{ color: '#fff', fontFamily: "'Inria Serif', serif", fontSize: '2rem' }} className="ms-2">KW</span>
              <span style={{ color: '#fff', fontFamily: "'Inria Serif', serif", fontSize: '1.4rem' }} className="ms-1">GOLD &amp; SILVER</span>
            </div>
          </div>
        </div>
      </div>

      <div className="container" style={{ paddingTop: '7rem' }}>
        <div className="col-12 d-flex align-items-center justify-content-center mt-5">
          <div className="fs-1" style={{ color: '#fff' }}>K</div>
          <div className="ms-2 me-2"><img src={logo} style={{ height: '6rem', width: '6rem' }} alt="" /></div>
          <div className="fs-1" style={{ color: '#fff' }}>W</div>
        </div>
        <div className="text-center mt-1 tagline">Gold &amp; Silver Accounting System</div>
        <div className="col-12 loginFormHead text-start">CAPITAL LOGIN</div>
        <div className="col-12 bgCustomForm my-5 ps-3 pe-3 py-5">
          <form onSubmit={handleSubmit}>
            <div className="col-12 emailField form-group">
              <label style={{ fontSize: '1.3rem', color: 'black' }}><i className="bi bi-person me-2"></i>Username</label>
              <input type="text" placeholder="username" className="form-control mt-2 border-dark userName" value={username} onChange={e => setUsername(e.target.value)} />
              <span className="toggle-email"><i className="bi bi-person"></i></span>
            </div>
            <div className="col-12 passwordField">
              <label className="label2"><i className="bi bi-lock me-2"></i>Password</label>
              <input type={showPass ? 'text' : 'password'} placeholder="password" className="form-control mt-2 border-dark userName" value={password} onChange={e => setPassword(e.target.value)} />
              <span className="toggle-password" style={{ cursor: 'pointer' }} onClick={() => setShowPass(!showPass)}>
                <i className={`bi ${showPass ? 'bi-eye-fill' : 'bi-eye-slash-fill'}`}></i>
              </span>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <button type="submit" className="d-flex align-items-center justify-content-center loginBtn">Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
